export default {
  primary: '#0c0e12',
  secondary: '#B13C2E',
  white: '#FFFFFF',
  grey_dark: '#0c0e12',
  grey_extra_dark: '#0a0c0f',
  grey_light: '#11161c',
  grey_blue: '#4f5e76',
  grey_extra_light: '#a4a4a4',
  grey_momo: '#dddddd',
};



// WEBPACK FOOTER //
// ./src/themes/light.js